import defaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const transaction = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  getters,
  mutations,
  actions,
}

export default transaction



// WEBPACK FOOTER //
// ./src/store/transaction/index.js